import { Alert, Card, CardBody, CardHeader, CardTitle } from '@apollo/orbit';
import { GraphQLError } from 'graphql';
import React from 'react';

import { NoSchemaFoundForContract } from 'src/components/publishSchema/noSchemaFoundForContract/NoSchemaNotFoundForContract';
import { PublishYourSchemaCard } from 'src/components/publishSchema/PublishYourSchemaCard';
import { BuildGraphQLSchemaError } from 'src/lib/errors/buildSchemaError/BuildSchemaError';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { IntrospectionFailure } from '../explorerPage/hooks/useExplorerState/useSchema/useSchemaFromEndpointIntrospection/useSchemaFromEndpointIntrospection';
import { GraphRef } from '../hooks/useGraphRef';
import { CompositionErrorsBanner } from '../subgraphsLayout/subgraphsPage/addSubgraphModal/CompositionErrorsBanner';

export const NoSchemaFoundCard = ({
  schemaError,
  graphRef,
  isContract = false,
  onPublishSchemaComplete,
}: {
  schemaError:
    | BuildGraphQLSchemaError[]
    | GraphQLTypes.BuildError[]
    | Error
    | IntrospectionFailure
    | readonly GraphQLError[]
    | undefined;
  graphRef: GraphRef;
  isContract?: boolean | null;
  onPublishSchemaComplete?: () => void;
}) => {
  const buildSchemaError =
    schemaError instanceof BuildGraphQLSchemaError ? schemaError : undefined;
  const buildSchemaErrors =
    schemaError &&
    Array.isArray(schemaError) &&
    (schemaError[0] instanceof BuildGraphQLSchemaError ||
      schemaError[0]?.__typename === 'BuildError')
      ? schemaError
      : undefined;

  // Contract variants don't support schema publishes directly to them.
  // We short circuit here to not display any of the schema publish steps.
  if (isContract) return <NoSchemaFoundForContract graphRef={graphRef} />;

  return (
    <div className="flex flex-col items-center justify-center px-8">
      {buildSchemaErrors || buildSchemaError ? (
        <Card className="m-8 w-full max-w-3xl">
          <CardHeader>
            <CardTitle>Error building schema</CardTitle>
          </CardHeader>
          <CardBody>
            {buildSchemaErrors && (
              <CompositionErrorsBanner
                errors={(Array.isArray(buildSchemaErrors)
                  ? buildSchemaErrors
                  : []
                ).map((error) => error.message)}
                graphRef={graphRef}
              />
            )}
            {buildSchemaError && (
              <Alert status="error">{buildSchemaError.message}</Alert>
            )}
            <p>Please try addressing the errors and register a new schema.</p>
          </CardBody>
        </Card>
      ) : (
        <PublishYourSchemaCard onComplete={onPublishSchemaComplete} />
      )}
    </div>
  );
};
